import React from 'react'
import { Link } from 'react-router-dom'

import CustomSlider from 'components/Slider'
import useDeviceDetect from 'components/DeviceDetect'

const BrandsSlider = props => {
  const { brands } = props
  const { isTablet } = useDeviceDetect()

  if (!brands || !brands.length) {
    return null
  }

  return (
    <>
      <div className="md:hidden brands-slider">
        <CustomSlider
          settings={{
            dots: false,
            swipeToSlide: true,
            slidesToShow: isTablet ? 6 : 4,
            autoplay: true,
            autoplaySpeed: 2000,
          }}
        >
          {brands.map(brand => (
            <Link
              key={brand.name}
              to={`brand/` + brand.slug}
              className="h-[85px] bg-[#F8FAFC] rounded-xl border border-[#F8FAFC] hover:border-slate-300 transform transition-all duration-300 hover:-translate-y-1 cursor-pointer p-4 sm:p-5 !flex items-center justify-center"
            >
              <img
                className="max-h-full"
                alt={brand.name}
                src={brand.image}
                loading="eager"
              />
            </Link>
          ))}
        </CustomSlider>
      </div>

      <div className="hidden md:grid grid-cols-8 gap-4">
        {brands.map(brand => (
          <Link
            key={brand.name}
            to={`brand/` + brand.slug}
            className="h-[85px] bg-[#F8FAFC] rounded-xl flex items-center justify-center border border-[#F8FAFC] hover:border-slate-300 transform transition-all duration-300 hover:-translate-y-1 cursor-pointer p-5"
          >
            <img
              className="max-h-full max-w-full"
              alt={brand.name}
              src={brand.image}
              loading="eager"
            />
          </Link>
        ))}
      </div>
    </>
  )
}

export default BrandsSlider
